import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

/* eslint-disable react/jsx-one-expression-per-line */

/* eslint-disable import/prefer-default-export */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '../icon/Icon';
import { makeCollapse, makeCollapseToggle, makeCollapseContent, makeToggleIcon } from './mixins';
var CollapseComponent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeCollapse(props);
});
var CollapseToggle = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeCollapseToggle(props);
});
var CollapseContent = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeCollapseContent(props);
});
var ToggleIcon = styled(Icon)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeToggleIcon(props);
});
export var Collapse = function Collapse(props) {
  var children = props.children,
      toggleLabel = props.toggleLabel,
      collapsed = props.collapsed,
      offset = props.offset,
      disabled = props.disabled,
      toggleIcon = props.toggleIcon;
  var externalState = disabled ? false : collapsed;

  var _useState = useState(collapsed),
      _useState2 = _slicedToArray(_useState, 2),
      internalState = _useState2[0],
      setInternalStatus = _useState2[1];

  return React.createElement(CollapseComponent, {
    collapsed: collapsed
  }, toggleLabel && React.createElement(CollapseToggle, {
    onClick: function onClick() {
      return setInternalStatus(disabled ? internalState : !internalState);
    }
  }, toggleIcon && React.createElement(ToggleIcon, {
    collapsed: internalState,
    name: toggleIcon,
    size: "20",
    color: "black"
  }), toggleLabel), React.createElement(CollapseContent, {
    collapsed: !disabled && externalState && (!toggleLabel || internalState),
    offset: offset
  }, children));
};
Collapse.propTypes = {
  children: PropTypes.node.isRequired,
  toggleLabel: PropTypes.node,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  offset: PropTypes.number,
  toggleIcon: PropTypes.string
};
Collapse.defaultProps = {
  collapsed: true,
  disabled: false,
  offset: 0,
  toggleIcon: '',
  toggleLabel: null
};